import { isWithCode } from '@orionprotocol/utils';
import { getMessageFromCode } from 'eth-rpc-errors';

type WalletError = {
  message: string;
  code?: number | string;
};

type ErrorConfig = {
  test: (e: Partial<WalletError>) => boolean;
  getError: (e: Partial<WalletError>) => WalletError;
};

const errors: ErrorConfig[] = [
  {
    test: (e) => isWithCode(e) && e.code === 'ACTION_REJECTED',
    getError: (e) => ({
      message: 'User rejected signing',
      code: e.code,
    }),
  },
  {
    test: (e) => e.message?.includes('LEDGER_WRONG_APP') ?? false,
    getError: () => ({
      message:
        'Please, check that ETH application is opened and Ledger is unlocked',
    }),
  },
  {
    test: (e) =>
      isWithCode(e) && typeof e.code === 'number'
        ? !!getMessageFromCode(e.code, '')
        : false,
    getError: (e) => ({
      message:
        isWithCode(e) && typeof e.code === 'number'
          ? getMessageFromCode(e.code, '')
          : '',
      code: e.code,
    }),
  },
];

export function getKnownWalletError(error: unknown): WalletError | undefined {
  if (!(error instanceof Object)) return undefined;

  return errors.find(({ test }) => test(error))?.getError(error);
}
